/***
 * @file: æé&&èåæå¡
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 * @desc æ­¤æå¡åªæå¨è¿è¡æééªè¯çæ¶åæä¼è¢«è°ç¨ï¼è¥é¡µé¢ä¸­æéæé®æ¯å¨æ¨¡ææ¡ä¸­ï¼åæå¼æ¨¡ææ¡ï¼æ­¤ç»ä»¶è¢«åå»ºæ¶ï¼æä¼è¿è¡æéæ ¡éª
 */

import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SettingsService } from './setting.service';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  constructor(private settingsSrv: SettingsService, private router: Router, private activeRoute: ActivatedRoute) {}

  /**
   * @desc å¤æ­æ¯å¦ææé
   * @param ä¼ å¥çæécodeç  `ADD`ä»£è¡¨æ°å¢
   * @return æ¯å¦æ¥ææ­¤æé
   */
  has(code: string) {
    let flag = false;
    this.settingsSrv.permissions.map((ele) => {
      if (ele.router === this.currentRouter) {
        return ele.opreations.indexOf(code) > -1 ? (flag = true) : null;
      }
    });

    // å¦æå­å¨åè¿åï¼ä¸å­å¨åå¤æ­æ¯å¦ä¸º 1104-EDITç±»å
    if (flag) {
      return flag;
    } else if (this.settingsSrv.modelIds.indexOf(code) > -1) {
      flag = true;
    }

    return flag;
  }

  getFullPath(routes: Array<ActivatedRoute>) {
    const paths: Array<string> = [];
    this.recursePath(routes, paths);
    return paths.join('/');
  }

  recursePath(routes: Array<ActivatedRoute>, paths: Array<string>) {
    if (routes && routes.length > 0) {
      const activeRoute: ActivatedRoute | undefined = routes[0];
      if (activeRoute) {
        const routeConfig: any = activeRoute.routeConfig || {};
        const path = routeConfig.path || '';
        if (path) {
          paths.push(path);
        }
        this.recursePath(activeRoute.children, paths);
      }
    }
  }

  get currentRouter(): string {
    let url = this.router.url || '';
    const path = this.getFullPath(this.activeRoute.children);
    if (path) {
      const rpath = path.replace(/(\/\:[a-z,A-Z]+)+/, '');
      const surl = url.slice(0, url.indexOf(rpath));
      url = surl + rpath;
    }

    return url;
  }
}
